import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconBuildingSvg } from './IconBuildingSvg';

export const IconBuilding: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconBuildingSvg} {...iconProps} />;
};
